import { render, staticRenderFns } from "./CampaignSetupsListHeader.vue?vue&type=template&id=bc332928&scoped=true"
import script from "./CampaignSetupsListHeader.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc332928",
  null
  
)

export default component.exports